import { createSelector } from 'selectors'

import { fileRights } from './constant'

const getFileManagerSections = () =>
	createSelector<NodeListOf<HTMLElement>>({ selector: fileRights.selector.fileManagerSection }, true)

export const getExpandCarets = (scope: HTMLElement) =>
	createSelector<NodeListOf<HTMLSelectElement>>({ scope, selector: fileRights.selector.expandCaret }, true)

export const getFileRightsComponents = () => ({
	sections: getFileManagerSections(),
})
